import Loadable from "react-loadable";
import LoadablePlaceholder from "./loadable-placeholder";

export default Loadable({ // eslint-disable-line new-cap
  loader: () => import("../pages/my-account"),
  loading: LoadablePlaceholder
});
